import React, {useRef} from 'react'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import {useTranslation} from 'react-i18next'
import styles
  from 'components/Shared/Dialogs/ContractorVerificationRequestDialog/ContractorVerificationRequestDialog.module.css'
import {PrimaryButton} from 'components/Shared/PrimaryButton'
import {Form, Formik} from "formik";
import {FieldComponent} from "../../FieldComponent";
import {useErrorHandling} from "../../../../context/errorHandling";
import {verifyContractor} from "../../../../services/ContractorService";
import DialogTitle from "@material-ui/core/DialogTitle";


export function ContractorVerificationRequestDialog({open, contractorId, onClose}) {

  const {t} = useTranslation()
  const {handleError} = useErrorHandling()
  const formRef = useRef()

  const handleClose = (sendEmail, buttonClose) => () => {
    if (!buttonClose) {
      return
    }
    if (sendEmail) {
      verifyContractor(contractorId, formRef.current.values.message)
        .catch((error) => handleError(error)).finally(onClose(sendEmail))
    } else {
      onClose(sendEmail)
    }
  }

  return (
    <div>
      <Dialog
        open={open}
        fullWidth
        maxWidth={'md'}
        onClose={handleClose(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"

      >
        <DialogTitle className={styles.titleContainer} id="alert-dialog-title">{t('contractorVerification.dialog.title')}</DialogTitle>
        <DialogContent>
          <DialogContentText className={styles.contentContainer}
                             id="alert-dialog-description">
            {t('contractorVerification.dialog.desc')}
          </DialogContentText>

          <div>
            <Formik initialValues={{message: ''}}
                    innerRef={formRef}
                    onSubmit={values => values}
            >
              <Form>
                <FieldComponent fieldName={'message'} label={'contractorVerification.dialog.inputLabel'}
                                multiline rowsMin={5} className={'w-100'}
                                onKeyDown={(e)=>e.stopPropagation()}/>
              </Form>
            </Formik>
          </div>
        </DialogContent>
        <DialogActions
          className={styles.dialogActions}
          disableSpacing
        >
          <div className={'p-1'}>
            <PrimaryButton
              className={styles.dialogButton}
              onClick={handleClose(true, true)}
              label={'common.confirm'}
            />
          </div>

          <div className={'p-1'}>
            <PrimaryButton
              onClick={handleClose(false, true)}
              label={'common.cancel'}
            />
          </div>
        </DialogActions>
      </Dialog>
    </div>
  )
}
